import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

import { useDispatch, useSelector } from 'react-redux';
import { Helmet } from 'react-helmet-async';
import { PAGES } from '../../constants/pages';
import {
  ACCOUNT_TYPE_UTMA_CUSTODIAN,
  ACCOUNT_TYPE_UTMA_TRUSTEE,
  APPLICATION_TYPE_UTMA,
} from '../../constants/accountTypes';
import SelectList from '../../components/SelectList/SelectList';
import BaseLayout from '../../components/BaseLayout';
import { Heading } from '../../components/Heading';
import { applicationTypeSetupSuccess } from '../../store/actions/application/applicationActions';
import { selectSettings } from '../../store/selectors/settingsSelectors';

const CreateApplicationUtma = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const dispatch = useDispatch();
  const { BrokerName } = useSelector(selectSettings);

  const options = [
    {
      title: t('selectPath.options.utma.custodian'),
      onClick: () => {
        dispatch(
          applicationTypeSetupSuccess({
            ApplicationType: APPLICATION_TYPE_UTMA,
            AccountType: ACCOUNT_TYPE_UTMA_CUSTODIAN,
          }),
        );
        history.push(PAGES.CREATE_ACCOUNT);
      },
    },
    {
      title: t('selectPath.options.utma.trust'),
      onClick: () => {
        dispatch(
          applicationTypeSetupSuccess({
            ApplicationType: APPLICATION_TYPE_UTMA,
            AccountType: ACCOUNT_TYPE_UTMA_TRUSTEE,
          }),
        );

        history.push(PAGES.CREATE_ACCOUNT);
      },
      showDivider: false,
    },
  ];

  return (
    <BaseLayout
      canShowEmail={false}
      previousPath={PAGES.CREATE_APPLICATION.MAIN}
    >
      <Helmet>
        <title>
          {t('selectPath.options.utma.titleTag', {
            brokerName: BrokerName,
          })}
        </title>
      </Helmet>
      <Heading mb={28}>{t('selectPath.options.utma.title')}</Heading>
      <SelectList options={options} />
    </BaseLayout>
  );
};

export default CreateApplicationUtma;
